import PeriprocedureelBeleidDabigatran from "../../../../src/client/lta-antistolling/periprocedureel-beleid-dabigatran.json";
import * as React from 'react';
export default {
  PeriprocedureelBeleidDabigatran,
  React
};